var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H24V9.5H7.5V15.5H10.5V12.5H13.5H21H24V15.5V18.5V21.5H21H13.5H10.5V18.5H6H4.5V17V9.5H0V0.5ZM21 15.5H13.5V18.5H21V15.5Z",
    fill: "#98BCD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryLarge);
export default __webpack_public_path__ + "static/media/category_large.84c7068e2f8c5a0e5992658d145678ba.svg";
export { ForwardRef as ReactComponent };